import React, { useEffect, useRef } from 'react';

import { CLUSTER_HEADER_CATEGORY } from 'utils/constant';

import { formatNumber,formatSubPageText } from '../../../utils';

const CareerClusterHeaderTitle = ({
  subPageName,
  title,
  showJobsCount = false,
  noH1Tag = false,
  clusterCategory,
  subPageTextSmall = true,
  jobTitleArticle,
  jobCount = '',
  getPageTitle,
}) => {
  const formattedSubPageName = formatSubPageText(subPageName, CLUSTER_HEADER_CATEGORY.CAREER);

  const TitleTag = noH1Tag ? 'p' : 'h1';
  const content = () => {
    if (subPageTextSmall) {
      {
        /* Note: the space after title below is required, DO NOT remove it. */
      }
      return (
        <>
          <span className="title text-break">{`${title} `}</span>
          {formattedSubPageName && <span className="subPageName">{formattedSubPageName}</span>}
        </>
      );
    }

    if (subPageName === 'best-states') return `Best States For ${jobTitleArticle} ${title}`;
    if (subPageName === 'what-they-do') return `What Does ${jobTitleArticle} ${title} Do?`;
    if (subPageName === 'how-to-become') return `How To Become ${jobTitleArticle} ${title}`;
    if (subPageName === 'jobs') return `${title} Jobs Near Me`;
    if (subPageName === 'remote-jobs') return `${title} Remote Jobs`;
    if (subPageName === 'overview') return `What is ${jobTitleArticle} ${title}?`;
    if (subPageName === 'certifications') return `Best ${title} ${formattedSubPageName}`;
    return `${title} ${formattedSubPageName}`;
  };
  const isJobsPage = subPageName?.toLowerCase()?.includes('jobs');
  const titleRef = useRef(null);

  if (getPageTitle) {
    useEffect(() => {
      const text = titleRef?.current?.textContent;
      getPageTitle(subPageTextSmall ? title : text);
    }, []);
  }

  return (
    <>
      {isJobsPage || showJobsCount ? (
        <div className="career-cluster-header-title career-title-only z-my-36" ref={titleRef}>
          <TitleTag>{content()}</TitleTag>
          <span className="d-inline">{` - ${formatNumber(jobCount)} Jobs`}</span>
        </div>
      ) : (
        <TitleTag className="career-cluster-header-title career-title-only z-my-36" ref={titleRef}>
          {content()}
        </TitleTag>
      )}
    </>
  );
};

export default CareerClusterHeaderTitle;
